import { render, staticRenderFns } from "./avatarChanger.vue?vue&type=template&id=611c5834"
import script from "./avatarChanger.vue?vue&type=script&lang=js"
export * from "./avatarChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports